import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import qs from 'qs';
import ApplicationAppService from '../platform/application-app-service';


let applicationData = ApplicationAppService.getApplicationData();

axios.defaults.baseURL = applicationData.baseUrl;


axios.defaults.paramsSerializer = {
  serialize: function (params: any) {
    return qs.stringify(params, { indices: false });
  }
}

const executeRequest = async (config: AxiosRequestConfig) => {
  const applicationData = ApplicationAppService.getAuthenticationData();

  config.headers = {
    Authorization: `Bearer ${applicationData?.bearerToken}`,
  }

  try {
    const result = await axios.request(config);
    return { data: result?.data || null };
  } catch (error) {
    // Processa o erro e cria um erro customizado com detalhes
    let errorMessage = 'Erro ao processar requisição';
    let errorDetails = '';

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<any>;

      // Cenário 1: Servidor respondeu com erro (4xx, 5xx)
      if (axiosError.response) {
        const responseData = axiosError.response.data;

        // Tratamento especial para erro 401 (Não autorizado)
        if (axiosError.response.status === 401) {
          ApplicationAppService.clearAuthenticationData();
          window.location.href = '/?action=login';
          errorMessage = 'Sessão expirada. É necessário fazer login novamente.';
          errorDetails = JSON.stringify({
            status: 401,
            message: 'Unauthorized - Redirecionando para login'
          }, null, 2);
        } else {
          // Extrai mensagem de erro do backend
          errorMessage =
            responseData?.message ||
            responseData?.error ||
            responseData?.title ||
            axiosError.response.statusText ||
            `Erro HTTP ${axiosError.response.status}`;

          // Se o backend retornou um objeto de erro estruturado (como PNCP), serializa ele direto
          if (responseData && typeof responseData === 'object') {
            try {
              errorDetails = JSON.stringify(responseData, null, 2);
            } catch {
              errorDetails = String(responseData);
            }
          }
        }

      // Cenário 2: Requisição feita mas sem resposta do servidor
      } else if (axiosError.request) {
        errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
        errorDetails = JSON.stringify({
          error: 'No response from server',
          url: axiosError.config?.url,
          method: axiosError.config?.method?.toUpperCase()
        }, null, 2);

      // Cenário 3: Erro na configuração da requisição
      } else {
        errorMessage = axiosError.message || 'Erro ao configurar requisição';
        errorDetails = JSON.stringify({
          error: 'Request configuration error',
          message: axiosError.message
        }, null, 2);
      }

    // Cenário 4: Erro não relacionado ao axios
    } else {
      errorMessage = (error as Error)?.message || 'Erro desconhecido';
      try {
        errorDetails = JSON.stringify({
          error: 'Non-axios error',
          message: errorMessage,
          type: (error as Error)?.constructor?.name || 'Unknown'
        }, null, 2);
      } catch {
        errorDetails = errorMessage;
      }
    }

    // Cria e lança o erro customizado
    const customError = new Error(errorMessage);
    (customError as any).details = errorDetails;
    (customError as any).originalError = error;

    throw customError;
  }
};



const HttpClient = {
  executeRequest
};

export default HttpClient;
